
export enum COMPETITION_TABS {
    all = 'all',
    draft = 'draft',
    announcement = 'announcement',
    open = 'open',
    voting = 'voting',
    completed = 'completed',
    deleted = 'deleted',
    special = 'special',
}
export enum COMPETITION_TABS {
    all = 'all',
    draft = 'draft',
    announcement = 'announcement',
    open = 'open',
    voting = 'voting',
    completed = 'completed',
    deleted = 'deleted',
    special = 'special',
}